import axios from 'axios'

export default () => {
    console.log('masuk getSpells ------====-----====--->')
    return (dispatch) => {
        axios.get('https://www.potterapi.com/v1/spells?key=$2a$10$ZDF7yaUXPhkdZHoIeg26H.phHi7ALfk7kfxFkUOoy8NROl1oMUPgi')
        .then(({data})=>{
            let spells = data.slice(0,50)
            dispatch({
                type : 'GET_SPELLS',
                spells
            })
        })
    }
}